import { userMapper } from 'app/scripts/components/moderation-v2/comments-and-posts/state/parsers';
import User from 'app/scripts/models/user';
import { LiveEvent, LiveEventTime } from './types';

export function parseLiveEvent(rawEvent: any): LiveEvent {
  return {
    id: rawEvent.id,
    eventCode: rawEvent.code,
    title: rawEvent.title,
    location: rawEvent.where,
    url: rawEvent.url,
    reporterIds: rawEvent.reporters_ids,
    start: parseLiveEventTime(rawEvent, 'start'),
    end: parseLiveEventTime(rawEvent, 'end'),
    timeZone: rawEvent.timezone,
    isEmbedded: rawEvent.last_seen > -1 || false,
    isFetched: false,
    createdAt: Math.round(rawEvent.timestamp)
  };
}

export function parseLiveEventData(rawEvent: any): { liveEvent: LiveEvent; reporters: User[] } {
  const liveEvent = { ...parseLiveEvent(rawEvent), isFetched: true };
  const reporters = Object.values(rawEvent.users || {}).map(userMapper);
  return { liveEvent, reporters };
}

export function parseLiveEventTime(rawEvent: any, type: 'start' | 'end'): LiveEventTime {
  const isStartTime = type === 'start';
  return {
    date: isStartTime ? rawEvent.date : rawEvent.end_date,
    hour: isStartTime ? rawEvent.hour : rawEvent.end_hour,
    minute: isStartTime ? rawEvent.minute : rawEvent.end_minute,
    time: isStartTime ? rawEvent.start_time : rawEvent.end_time
  };
}
